import { render, staticRenderFns } from "./reqDetail.vue?vue&type=template&id=2840cc9d"
import script from "./reqDetail.vue?vue&type=script&lang=js"
export * from "./reqDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports